const SUCCESS_STATUSES = new Set(['matched', 'partially_matched', 'entry_created']);
const PENDING_STATUSES = new Set(['', 'uploaded', 'queued', 'pending', 'processing', 'ocr_processing', 'matching']);
const REVIEW_STATUSES = new Set(['manual_review', 'redemption_unclear', 'review_required', 'needs_review']);
const NOT_MATCHED_STATUSES = new Set(['not_matched', 'unmatched', 'no_match']);
const FAILED_STATUSES = new Set(['failed', 'error', 'processing_failed', 'rejected']);

export function normalizeReceiptRedemptionStatus(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, '_');
}

export function getReceiptRedemptionStatus(result) {
  return normalizeReceiptRedemptionStatus(
    result?.redemption_status || result?.match?.status || ''
  );
}

export function classifyReceiptRedemption(result) {
  const status = getReceiptRedemptionStatus(result);
  if (SUCCESS_STATUSES.has(status)) return 'success';
  if (REVIEW_STATUSES.has(status)) return 'review';
  if (NOT_MATCHED_STATUSES.has(status)) return 'not_matched';
  if (FAILED_STATUSES.has(status)) return 'failed';
  if (PENDING_STATUSES.has(status) || result?.client_status_timeout) return 'processing';
  return 'processing';
}

export function isTerminalReceiptRedemption(result) {
  return classifyReceiptRedemption(result) !== 'processing';
}

export function getReceiptRedeemedAmount(result) {
  const finalCents = Number(result?.match_summary?.final_accounted_cents);
  if (Number.isFinite(finalCents) && finalCents > 0) return Math.round(finalCents) / 100;

  const matchedAmount = Number(result?.matched_amount);
  if (Number.isFinite(matchedAmount) && matchedAmount > 0) return matchedAmount;

  const depositAmount = Number(result?.deposit_amount);
  return Number.isFinite(depositAmount) && depositAmount > 0 ? depositAmount : 0;
}

export function formatReceiptCurrency(value) {
  return Number(value || 0).toLocaleString('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function getReceiptRedemptionMessage(result) {
  const classification = classifyReceiptRedemption(result);
  if (classification === 'success') {
    const amount = formatReceiptCurrency(getReceiptRedeemedAmount(result));
    if (getReceiptRedemptionStatus(result) === 'entry_created') {
      return `Pfandbon erfolgreich erkannt! ${amount} wurden als eingelöster Pfandeintrag erfasst.`;
    }
    return `Pfandbon erfolgreich erkannt! ${amount} wurden deinen offenen Pfandeinträgen zugeordnet und eingelöst.`;
  }
  if (classification === 'review') {
    return 'Dein Pfandbon wurde erkannt und wird noch geprüft. Du erhältst eine Rückmeldung, sobald die Prüfung abgeschlossen ist.';
  }
  if (classification === 'not_matched') {
    return 'Der Pfandbon wurde erkannt, konnte aber aktuell keinen offenen Pfandeinträgen zugeordnet werden.';
  }
  if (classification === 'failed') {
    return 'Der Pfandbon konnte aufgrund eines technischen Fehlers nicht vollständig verarbeitet werden. Bitte versuche es später erneut.';
  }
  if (result?.client_status_timeout) {
    return 'Dein Pfandbon wird weiterhin geprüft. Der aktuelle Stand wird beim nächsten Öffnen automatisch geladen.';
  }
  return 'Dein Pfandbon wird geprüft …';
}

export function beginReceiptSubmission(lockRef) {
  if (!lockRef || lockRef.current) return false;
  lockRef.current = true;
  return true;
}

export function endReceiptSubmission(lockRef) {
  if (lockRef) lockRef.current = false;
}
